import { portalHttp } from '../portalHttp';
import { PortalPage } from '../portalApi';

// ---- F8 supplier portal: API calls under /portal/supplier (shapes mirror SupplierPortalDtos) ----
export const PORTAL_PARTY_KEY = 'portalParty';
export type PortalParty = 'CUSTOMER' | 'SUPPLIER';
export const getPortalParty = (): PortalParty | null => {
  try { return sessionStorage.getItem(PORTAL_PARTY_KEY) as PortalParty | null; } catch { return null; }
};
export const setPortalParty = (p: PortalParty): void => {
  try { sessionStorage.setItem(PORTAL_PARTY_KEY, p); } catch { /* storage blocked */ }
};

export interface SupplierMe { contactName: string; email: string; supplierName: string; institutionName: string; institutionCode: string; }
export interface SupplierPoRow {
  id: string; poNumber: string; orderDate: string; expectedDate?: string | null; status: string; currency: string;
  totalAmount: number; acknowledgedAt?: string | null;
}
export interface SupplierPoLine { itemCode: string; itemName: string; quantity: number; unitPrice: number; lineTotal: number; deliveryDate?: string | null; }
export interface SupplierPoDetail {
  id: string; poNumber: string; orderDate: string; expectedDate?: string | null; status: string; currency: string;
  subtotal: number; taxAmount: number; totalAmount: number; acknowledgedAt?: string | null; acknowledgedNote?: string | null;
  canAcknowledge: boolean; lines: SupplierPoLine[];
}
export interface SupplierBillRequestRow {
  id: string; requestNo: string; supplierInvoiceNo: string; invoiceDate: string; amount: number; purchaseOrderId?: string | null;
  poNumber?: string | null; description?: string | null; status: string; reviewComment?: string | null; hasFile: boolean; submittedAt: string;
}
export interface BillRequestSubmit { file: File; invoiceNo: string; invoiceDate: string; amount: string; purchaseOrderId?: string; description?: string; }

const S = '/supplier';
export const SupplierPortalApi = {
  me: async (): Promise<SupplierMe> => (await portalHttp.get(`${S}/auth/me`)).data,
  logout: async (): Promise<void> => { await portalHttp.post(`${S}/auth/logout`); },
  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await portalHttp.post(`${S}/me/password`, { currentPassword, newPassword });
  },
  pos: async (page: number, size: number): Promise<PortalPage<SupplierPoRow>> =>
    (await portalHttp.get(`${S}/pos`, { params: { page, size } })).data,
  po: async (id: string): Promise<SupplierPoDetail> => (await portalHttp.get(`${S}/pos/${id}`)).data,
  poPdf: async (id: string): Promise<Blob> => (await portalHttp.get(`${S}/pos/${id}/pdf`, { responseType: 'blob' })).data,
  acknowledge: async (id: string, note: string): Promise<SupplierPoDetail> =>
    (await portalHttp.post(`${S}/pos/${id}/acknowledge`, { note: note || null })).data,
  billRequests: async (): Promise<SupplierBillRequestRow[]> => (await portalHttp.get(`${S}/bill-requests`)).data,
  submitBillRequest: async (r: BillRequestSubmit): Promise<SupplierBillRequestRow> => {
    const fd = new FormData();
    fd.append('file', r.file);
    fd.append('invoiceNo', r.invoiceNo);
    fd.append('invoiceDate', r.invoiceDate);
    fd.append('amount', r.amount);
    if (r.purchaseOrderId) fd.append('purchaseOrderId', r.purchaseOrderId);
    if (r.description) fd.append('description', r.description);
    return (await portalHttp.post(`${S}/bill-requests`, fd)).data;
  },
  withdraw: async (id: string): Promise<SupplierBillRequestRow> => (await portalHttp.post(`${S}/bill-requests/${id}/withdraw`)).data,
};
// ---- end F8 ----
